import { Component, Inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface TaskApprovalConfirmDialogData {
  isApproved: boolean;
  proposalNumber: string | number;
  comment: string;
}

@Component({
  selector: 'task-approval-confirm-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslocoDirective],
  templateUrl: './task-approval-confirm-dialog.html',
  styleUrl: './task-approval-confirm-dialog.scss',
})
export class TaskApprovalConfirmDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: TaskApprovalConfirmDialogData,
  ) {}
}
